import { Col, Row } from 'antd';
import React from 'react';
import { Project } from '../../redux/projectSlice';
import TestCaseListViewItem from './ProjectListViewItem';
import ClientSidePagination from '../../components/Pagination/ClientSidePagination';

interface ProjectListProps {
  projects: Array<Project>
  deleteProject: Function
  currentPage: number
  pageSize: number
  total: number
  onPaginationChange: (page: number, pageSize: number) => void
}

const ProjectListView = ({
  projects = [],
  deleteProject,
  currentPage,
  pageSize,
  total,
  onPaginationChange,
}: ProjectListProps) => {
  const projectList = projects.map((project: Project) => (
    <TestCaseListViewItem project={project} key={project.projectId} deleteProject={deleteProject} />
  ));
  const noDataView = <Row justify="center"><p>No Projects Found.</p></Row>;
  const renderView = projects.length > 0 ? projectList : noDataView;
  return (
    <div className="fp_list">
      <Row justify="space-between" className="fp_list_title">
        <Col span={6}><p>Project Name</p></Col>
        {/* <Col span={6}><p>Type</p></Col> */}
        {/* <Col span={6}><p>Service Type</p></Col> */}
        <Col span={11}><p>Created At</p></Col>
      </Row>
      {renderView}
      <ClientSidePagination
        currentPage={currentPage}
        total={total}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
      />
    </div>
  );
};

export default ProjectListView;
